import React, { useState } from 'react';
import './MentoringProgram.css';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import PageHeader from '../about/PageHeader';
import Footer from '../components/Footer';

const StudentMentoringProgram = () => {
  // State to handle accordion open/close on mobile
  const [activeTab, setActiveTab] = useState(null);

  const toggleTab = (tabIndex) => {
    // If clicking the already open tab, close it. Otherwise, open the new one.
    if (activeTab === tabIndex) {
      setActiveTab(null);
    } else {
      setActiveTab(tabIndex);
    }
  };

  return (
    <>
      <Navbar />
      <CTAButton />
      <PageHeader
        title="Student Mentoring Program"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Student Mentoring Program' }]}
      />
      
      <div className="smp-wrapper">
        
        {/* Intro Text */}
        <p className="smp-intro-text">
          TIMSCDR offers a comprehensive Student Mentoring Program for students pursuing an MCA master degree. After the admission process is complete, every student is assigned a faculty mentor for the entire duration of the MCA program. These mentors interact with students regularly to assess and identify problem areas in their learning and development processes, guiding them throughout their MCA master degree journey.
        </p>

        {/* Duties Section - Responsive Accordion */}
        <div className="smp-duties-container">
          
          {/* Mentor Column */}
          <div className={`smp-duties-column ${activeTab === 1 ? 'is-open' : ''}`}>
            <div className="smp-duties-header" onClick={() => toggleTab(1)}>
              <div className="smp-icon-circle-small">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3 className="smp-card-title">Duties/ Responsibilities of Mentor</h3>
              {/* Accordion Icon - Only visible on mobile */}
              <span className="smp-accordion-icon">{activeTab === 1 ? '−' : '+'}</span>
            </div>
            <p className="smp-card-desc">The mentor has to play the role of a self designated guardian to the assigned mentees. The mentor has to ensure overall wellbeing of their mentees and has to make sure that any personal information shared by the mentee with them in good faith is not divulged to anyone else. They have to –</p>
            <ul className="smp-card-list">
              <li>Conduct an orientation meeting for the assigned mentees and brief them about the process of Student Mentoring Program</li>
              <li>Collect all required data of mentees & update it regularly</li>
              <li>Keep track of attendance, academic performance and behavioral aspects of the mentee by interacting with them on a regular basis.</li>
              <li>As and when required obtain data about the mentee from HoD Academics, examination department etc</li>
              <li>Help mentees resolve any issues they face academically or otherwise</li>
              <li>Guide mentees in their academic projects and research paper</li>
              <li>Identify mentees with specific skills and refer them to relevant committees</li>
              <li>Support mentees academically and emotionally and encourage them to upgrade themselves</li>
              <li>Interact with parents about progress of their ward, whenever required</li>
            </ul>
          </div>

          {/* Mentee Column */}
          <div className={`smp-duties-column smp-border-left ${activeTab === 2 ? 'is-open' : ''}`}>
            <div className="smp-duties-header" onClick={() => toggleTab(2)}>
              <div className="smp-icon-circle-small">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3 className="smp-card-title">Duties/Responsibilities of the Mentees</h3>
              {/* Accordion Icon - Only visible on mobile */}
              <span className="smp-accordion-icon">{activeTab === 2 ? '−' : '+'}</span>
            </div>
            <p className="smp-card-desc">The Student Mentoring Program cannot be effective if it is not embraced by mentees wholeheartedly. The mentees should –</p>
            <ul className="smp-card-list">
              <li>Provide all personal and other details required by the mentor</li>
              <li>Attend meetings regularly and engages in quality voluntary interaction</li>
              <li>Provide details of attendance, examination, any other assessments, co-curricular, extra-curricular activities to the mentor proactively</li>
              <li>Have confidence in the mentor and seek his/her advice whenever required</li>
            </ul>
          </div>

        </div>

      </div>
      <Footer />
    </>
  );
};

export default StudentMentoringProgram;